(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea202"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea202"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
// src/js/login.js

var $5Gd8p = parcelRequire("5Gd8p");

var $kkiei = parcelRequire("kkiei");
const $2e9821e67a93167d$var$loginForm = document.getElementById("loginForm");
const $2e9821e67a93167d$var$passwordInput = document.getElementById("password");
const $2e9821e67a93167d$var$loginBtn = document.getElementById("loginBtn");
const $2e9821e67a93167d$var$btnText = $2e9821e67a93167d$var$loginBtn?.querySelector(".btn-text");
const $2e9821e67a93167d$var$btnSpinner = $2e9821e67a93167d$var$loginBtn?.querySelector(".btn-spinner");
const $2e9821e67a93167d$var$loginError = document.getElementById("loginError");
// Check if already logged in
const $2e9821e67a93167d$var$savedFridge = (0, $kkiei.getCurrentFridgeCode)();
if ($2e9821e67a93167d$var$savedFridge) // Already logged in, redirect to inventory
window.location.href = "inventory.html";
// Initialize Firebase
(0, $5Gd8p.initializeFirebase)().then(()=>{
    console.log("Firebase ready for login");
}).catch((err)=>{
    console.error("Firebase init error:", err);
});
$2e9821e67a93167d$var$loginForm?.addEventListener("submit", async (e)=>{
    e.preventDefault();
    const password = $2e9821e67a93167d$var$passwordInput?.value?.trim();
    if (!password) return;
    // Show loading state
    $2e9821e67a93167d$var$setLoading(true);
    $2e9821e67a93167d$var$hideError();
    try {
        const fridge = await (0, $kkiei.findFridgeByPassword)(password);
        if (fridge && fridge.code) {
            // Save fridge code and redirect
            (0, $kkiei.setCurrentFridgeCode)(fridge.code);
            window.location.href = "inventory.html";
        } else $2e9821e67a93167d$var$showError("Feil passord. Pr\xf8v igjen.");
    } catch (err) {
        console.error("Login error:", err);
        $2e9821e67a93167d$var$showError("Noe gikk galt. Pr\xf8v igjen.");
    } finally{
        $2e9821e67a93167d$var$setLoading(false);
    }
});
function $2e9821e67a93167d$var$setLoading(loading) {
    if ($2e9821e67a93167d$var$loginBtn) $2e9821e67a93167d$var$loginBtn.disabled = loading;
    if ($2e9821e67a93167d$var$btnText) $2e9821e67a93167d$var$btnText.hidden = loading;
    if ($2e9821e67a93167d$var$btnSpinner) $2e9821e67a93167d$var$btnSpinner.hidden = !loading;
}
function $2e9821e67a93167d$var$showError(message) {
    if ($2e9821e67a93167d$var$loginError) {
        $2e9821e67a93167d$var$loginError.textContent = message;
        $2e9821e67a93167d$var$loginError.hidden = false;
    }
}
function $2e9821e67a93167d$var$hideError() {
    if ($2e9821e67a93167d$var$loginError) $2e9821e67a93167d$var$loginError.hidden = true;
}

})();
//# sourceMappingURL=index.02766e25.js.map
